export default __webpack_public_path__ + "static/media/Content2.8510a352.svg";